import type { GetMockOrganizationDetailParams, MockOrganizationDetail } from '../types';

const DEFAULT_MOCK: MockOrganizationDetail = {
    name: 'Acme Corp',
    createdAtLabel: 'Jan 15, 2024',
    ageLabel: '568 days',
    subscription: {
        status: 'active',
        planName: 'Growth',
        customerId: 'cus_Acme9x2k',
        subscriptionId: 'sub_1PxAcme',
        currentPeriodStart: '2026-07-01',
        currentPeriodEnd: '2026-08-01',
        nextPaymentAmountCents: 24900,
        nextPaymentCurrency: 'usd',
        nextPaymentDueLabel: 'Aug 1',
        billingCycleProgressPercent: 61,
        billingCycleDaysLeftLabel: '12 days left',
    },
};

const getMockOrganizationDetail = ({
    organizationId,
}: GetMockOrganizationDetailParams): MockOrganizationDetail => ({
    ...DEFAULT_MOCK,
    name: organizationId === 'org-acme' ? 'Acme Corp' : `Organization ${organizationId}`,
});

export default getMockOrganizationDetail;
